import React from 'react';
import { BookOpen } from 'lucide-react';

const ESSENTIALS = [
  {
    title: 'Large lot sizes',
    tag: 'Capital Needed',
    tone: 'border-emerald-200 bg-emerald-50/60',
    tagTone: 'bg-emerald-600 text-white',
    body: 'SME shares are allotted and traded in large lots, so one application needs far more capital than a typical mainboard bid. Check the per-lot value before applying.',
  },
  {
    title: 'Separate exchange platforms',
    tag: 'NSE Emerge · BSE SME',
    tone: 'border-amber-200 bg-amber-50/60',
    tagTone: 'bg-amber-500 text-white',
    body: 'SME issues list on NSE Emerge or BSE SME rather than the main board, and continue to trade in lots after listing.',
  },
  {
    title: 'Market maker, thin volumes',
    tag: 'Liquidity',
    tone: 'border-violet-200 bg-violet-50/60',
    tagTone: 'bg-violet-600 text-white',
    body: 'Every SME issue has a designated market maker quoting buy and sell prices, but trading volumes stay far lower than in mainboard stocks.',
  },
  {
    title: 'Exchange-vetted offer documents',
    tag: 'Due Diligence',
    tone: 'border-rose-200 bg-rose-50/60',
    tagTone: 'bg-rose-600 text-white',
    body: 'SME offer documents are reviewed by the stock exchange rather than SEBI. Read the RHP closely: promoter background, related-party dealings and cash flows.',
  },
];

export const SmeEssentialsGuide = () => (
  <section aria-labelledby="sme-essentials-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex items-start gap-3">
      <span className="w-9 h-9 rounded-xl bg-teal-50 text-[#008080] border border-teal-100 flex items-center justify-center shrink-0">
        <BookOpen className="w-4 h-4" />
      </span>
      <div>
        <h2 id="sme-essentials-heading" className="text-sm sm:text-base font-extrabold text-slate-900">
          SME IPO Essentials
        </h2>
        <p className="text-xs text-slate-500">How SME issues differ from mainboard IPOs before you apply</p>
      </div>
    </div>
    <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      {ESSENTIALS.map((item) => (
        <li key={item.title} className={`rounded-xl border p-3.5 ${item.tone}`}>
          <span className={`inline-flex px-2 py-0.5 rounded text-[10px] font-extrabold uppercase tracking-wide ${item.tagTone}`}>{item.tag}</span>
          <p className="mt-2 text-sm font-bold text-slate-900">{item.title}</p>
          <p className="mt-1 text-xs text-slate-600 leading-relaxed">{item.body}</p>
        </li>
      ))}
    </ul>
  </section>
);

export default SmeEssentialsGuide;
